import * as React from "react";
// import { pure } from 'recompose';
import { Link } from "react-router-dom";
import * as Paths from "@tunnel-enums/index";
import { CSVLink } from "react-csv";
import IconSvgBreadCrumb from "@tunnel-components/@sharded/@widgets/svg/component";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import StyledIcon from "@tunnel-components/@sharded/@widgets/icons/component";
import * as i18next from "i18next";
// import * as Lodash from 'lodash';
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    title,
    bulles,
    filtreLapi,
    onClearIncidentSearch,
    iconIncident,
    onExportCSVCamera,
    lapiincons,
    filtreHistoryCitilog,
    onClosehoverCard,
    onPenSearchIncidents,
    iconSupervision,
    iconAdministration,
    iconExplorer,
    links1,
    csvData,
    UsersAdd,
    onOpenAddUser,
    breadText1,
    breadText2,
    addIhnibition,
    onOpenInhibitionModal,
    filtreHistory,
    onFilterReset,
    onOpenhoverCard,
    openHoverCard,
    onFilter,
    cameraIsExist,
    actionFinished,
    links,
    actionInProgress,
    ficheIncident,
    onExtractPdf,
    onExtractVideo,
    onSegmented,
  } = props;
  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name react-router-dom
   * @name react-csv
   * @infos "https://reactjs.org"
   */

  const authViewTubes: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.SYSTEMVIEWTUBES,
  ]);

  const authInfoIncidents: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.EXPORT_CSV_INFO_INCIDENTS,
  ]);

  const authInfoVehicles: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.EXPORT_CSV_INFO_VEHICLE,
  ]);

  if (!authViewTubes && csvData && csvData.length > 0) {
    csvData.map((element: any) => {
      delete element.tube;
      return element;
    });
  }

  if (!authInfoIncidents && csvData && csvData.length > 0) {
    csvData.map((element: any) => {
      delete element.qualificationMotif;
      delete element.snapshot;
      delete element.snapshotMim;
      delete element.incidentTypeId;
      delete element.fake;
      delete element.terminated;
      delete element.qualified;

      return element;
    });
  }

  if (!authInfoVehicles && csvData && csvData.length > 0) {
    csvData.map((element: any) => {
      delete element.vehicleSpeed;
      delete element.vehicleNombre;
      delete element.vehicleDistance;
      return element;
    });
  }

  return (
    <div className="breadcrumb">
      <div className="breadcrumb-header">
        <div className="breadcrumb-infos">
          <div className="breadcrumb-action left">
            <IconSvgBreadCrumb
              width="25"
              height="25"
              administration={iconAdministration}
              lapiincons={lapiincons}
              incidents={iconIncident}
              explorer={iconExplorer}
              supervision={iconSupervision}
            />
            {title && links && (
              <span className="title-breadcrumb ">
                <Link to={{ pathname: links }}>{title}</Link>
              </span>
            )}
            {title && !links && (
              <span className="title-breadcrumb ">{title}</span>
            )}
            {breadText1 && !links1 && (
              <span className="breadcrumb-text animated fadeInDown">
                {breadText1}
              </span>
            )}
            {breadText1 && links1 && (
              <span className="breadcrumb-text animated fadeInDown">
                <Link to={{ pathname: links1 }}>{breadText1}</Link>
              </span>
            )}
            {breadText2 && (
              <span className="breadcrumb-next animated fadeInDown">
                {breadText2}
              </span>
            )}
            {actionFinished && !actionInProgress && (
              <span className="action-incidents isFinished-btn">
                {i18next.t("terminer")}
              </span>
            )}
            {!actionFinished && actionInProgress && (
              <span className="action-incidents ">
                {" "}
                {i18next.t("en cours")}
              </span>
            )}
          </div>
          {filtreHistory && (
            <div className="breadCrumbLeft left ">
              <div className="breadCrumbContainer">
                <span className="breadCrumbText">
                  <Styled.Container onMouseLeave={onClosehoverCard}>
                    {!!bulles && (
                      <Styled.BoxContainersuggestionText
                        style={{ fontSize: "15px" }}
                      >
                        <div
                          style={{ height: "auto" }}
                          onClick={onClearIncidentSearch}
                        >
                          <div
                            style={{
                              display: "inline-block",
                              float: "left",
                              lineHeight: "28px",
                            }}
                          >
                            {" "}
                            <span>{bulles}</span>{" "}
                          </div>
                          <div
                            style={{ display: "inline-block" }}
                            title={i18next.t("supprimer")}
                          >
                            <svg
                              style={{
                                marginLeft: "5px",
                                marginTop: "3px",
                                transform: "rotate(45deg)",
                                cursor: "pointer",
                              }}
                              viewBox="0 0 24 24"
                              width="20px"
                              height="20px"
                            >
                              <path
                                fill="#a8b4c0"
                                d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm4.8 13.2h-3.6v3.6a1.2 1.2 0 0 1-2.4 0v-3.6H7.2a1.2 1.2 0 1 1 0-2.4h3.6V7.2a1.2 1.2 0 1 1 2.4 0v3.6h3.6a1.2 1.2 0 0 1 0 2.4z"
                              />
                            </svg>
                          </div>
                        </div>
                      </Styled.BoxContainersuggestionText>
                    )}

                    {(Utils.simpleAuthorizationIsAllowed(User, [
                      Enums.AuthorizationRightsEnums.EXPLORERFILTRERLETABLEAU,
                    ]) ||
                      Utils.simpleAuthorizationIsAllowed(User, [
                        Enums.AuthorizationRightsEnums.EXPLORERFILTRERLETABLEAU,
                      ])) && (
                      <Styled.BreadContainerBalise
                        onClick={onPenSearchIncidents}
                        style={{
                          background: "transparent",
                          borderRadius: "unset",
                          border: "none",
                          width: "45px",
                          cursor: "pointer",
                          marginLeft: "12px",
                          marginRight: "30px",
                          marginTop: "5px",
                        }}
                      >
                        <Styled.Icon
                          style={{ width: "auto" }}
                          onClick={onPenSearchIncidents}
                        >
                          <StyledIcon
                            explorer={true}
                            color="rgb(0, 122, 223)"
                          />
                        </Styled.Icon>
                      </Styled.BreadContainerBalise>
                    )}

                    <Styled.BreadContainerBalise
                      onClick={onOpenhoverCard}
                      style={{
                        background: "#007ADF",
                        border: "none",
                        width: "auto",
                        cursor: "pointer",
                      }}
                    >
                      <p
                        style={{
                          marginRight: "35px",
                          padding: "0 5px 0 10px",
                          color: "white",
                        }}
                      >
                        {i18next.t("actions")}
                      </p>
                      <Styled.IconRotate
                        rotates={!openHoverCard}
                        style={{ width: "10px", right: "10px" }}
                      >
                        <StyledIcon arrowWite={true} />
                      </Styled.IconRotate>
                    </Styled.BreadContainerBalise>
                    <Styled.BreadBoxContainer
                      isVisible={openHoverCard}
                      style={{ minWidth: "220px", right: "0" }}
                    >
                      {Utils.simpleAuthorizationIsAllowed(User, [
                        Enums.AuthorizationRightsEnums.EXPLORERFILTRERLETABLEAU,
                      ]) && (
                        <div className="actionText" onClick={onFilter}>
                          <div className="actionIcon left">
                            <IconSvgBreadCrumb
                              width="25"
                              height="25"
                              filtre={true}
                              color="rgb(0, 122, 223)"
                            />
                          </div>
                          <p className="actionTitle left">
                            {i18next.t("filtres")}
                          </p>
                        </div>
                      )}

                      {Utils.simpleAuthorizationIsAllowed(User, [
                        Enums.AuthorizationRightsEnums.EXPLORERFILTRERLETABLEAU,
                      ]) && (
                        <div className="actionText" onClick={onFilterReset}>
                          <div className="actionIcon left">
                            <IconSvgBreadCrumb
                              width="25"
                              height="25"
                              filtre={true}
                              color="#9a9696"
                            />
                          </div>
                          <p className="actionTitle left">
                            {i18next.t("reinitialiser les filtres")}
                          </p>
                        </div>
                      )}

                      {Utils.simpleAuthorizationIsAllowed(User, [
                        Enums.AuthorizationRightsEnums
                          .EXPLOREREXPORTERCSVLETABLEAU,
                      ]) && (
                        <div className="actionText">
                          <div className="actionIcon left">
                            <IconSvgBreadCrumb
                              width="25"
                              height="25"
                              exportFilePDF={true}
                            />
                          </div>
                          <p className="actionTitle left">
                            <CSVLink
                              target="_blank"
                              filename="export-du-tableau.csv"
                              data={csvData}
                            >
                              {" "}
                              {i18next.t("exporter les incidents")}
                            </CSVLink>
                          </p>
                        </div>
                      )}
                    </Styled.BreadBoxContainer>
                  </Styled.Container>
                </span>
              </div>
            </div>
          )}
          {filtreHistoryCitilog && (
            <div className="breadCrumbLeft left ">
              <div className="breadCrumbContainer">
                <span className="breadCrumbText">
                  <Styled.Container onMouseLeave={onClosehoverCard}>
                    <Styled.BreadContainerBalise
                      onClick={onOpenhoverCard}
                      style={{
                        background: "#007ADF",
                        border: "none",
                        width: "auto",
                        cursor: "pointer",
                      }}
                    >
                      <p
                        style={{
                          marginRight: "35px",
                          padding: "0 5px 0 10px",
                          color: "white",
                        }}
                      >
                        {i18next.t("actions")}
                      </p>
                      <Styled.IconRotate
                        rotates={!openHoverCard}
                        style={{ width: "10px", right: "10px" }}
                      >
                        <StyledIcon arrowWite={true} />
                      </Styled.IconRotate>
                    </Styled.BreadContainerBalise>
                    <Styled.BreadBoxContainer
                      isVisible={openHoverCard}
                      style={{ minWidth: "220px", right: "0" }}
                    >
                      <div className="actionText">
                        <div className="actionIcon left">
                          <IconSvgBreadCrumb
                            width="25"
                            height="25"
                            upload={true}
                          />
                        </div>
                        <p className="actionTitle left">
                          <CSVLink
                            target="_blank"
                            filename="export-incidents-citilog.csv"
                            data={csvData}
                          >
                            {i18next.t("exporter les incidents")}
                          </CSVLink>
                        </p>
                      </div>
                    </Styled.BreadBoxContainer>
                  </Styled.Container>
                </span>
              </div>
            </div>
          )}
          {filtreLapi &&
            Utils.simpleAuthorizationIsAllowed(User, [
              Enums.AuthorizationRightsEnums.TMDLAPIEXPORTERPDF,
            ]) && (
              <div className="breadCrumbLeft left ">
                <div className="breadCrumbContainer">
                  <span className="breadCrumbText">
                    <Styled.Container onMouseLeave={onClosehoverCard}>
                      {!!bulles && (
                        <Styled.BoxContainersuggestionText
                          style={{ fontSize: "15px" }}
                        >
                          <div
                            style={{ height: "auto" }}
                            onClick={onClearIncidentSearch}
                          >
                            <div
                              style={{
                                display: "inline-block",
                                float: "left",
                                lineHeight: "28px",
                              }}
                            >
                              {" "}
                              <span>{bulles}</span>{" "}
                            </div>
                            <div
                              style={{ display: "inline-block" }}
                              title={i18next.t("supprimer")}
                            >
                              <svg
                                style={{
                                  marginLeft: "5px",
                                  marginTop: "3px",
                                  transform: "rotate(45deg)",
                                  cursor: "pointer",
                                }}
                                viewBox="0 0 24 24"
                                width="20px"
                                height="20px"
                              >
                                <path
                                  fill="#a8b4c0"
                                  d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm4.8 13.2h-3.6v3.6a1.2 1.2 0 0 1-2.4 0v-3.6H7.2a1.2 1.2 0 1 1 0-2.4h3.6V7.2a1.2 1.2 0 1 1 2.4 0v3.6h3.6a1.2 1.2 0 0 1 0 2.4z"
                                />
                              </svg>
                            </div>
                          </div>
                        </Styled.BoxContainersuggestionText>
                      )}
                      <Styled.BreadContainerBalise
                        onClick={onPenSearchIncidents}
                        style={{
                          background: "transparent",
                          borderRadius: "unset",
                          border: "none",
                          width: "45px",
                          cursor: "pointer",
                          marginLeft: "12px",
                          marginRight: "30px",
                          marginTop: "5px",
                        }}
                      >
                        <Styled.Icon
                          style={{ width: "auto" }}
                          onClick={onPenSearchIncidents}
                        >
                          <StyledIcon
                            explorer={true}
                            color="rgb(0, 122, 223)"
                          />
                        </Styled.Icon>
                      </Styled.BreadContainerBalise>
                      <Styled.BreadContainerBalise
                        onClick={onOpenhoverCard}
                        style={{
                          background: "#007ADF",
                          border: "none",
                          width: "auto",
                          cursor: "pointer",
                        }}
                      >
                        <p
                          style={{
                            marginRight: "35px",
                            padding: "0 5px 0 10px",
                            color: "white",
                          }}
                        >
                          {i18next.t("actions")}
                        </p>
                        <Styled.IconRotate
                          rotates={!openHoverCard}
                          style={{ width: "10px", right: "10px" }}
                        >
                          <StyledIcon arrowWite={true} />
                        </Styled.IconRotate>
                      </Styled.BreadContainerBalise>
                      <Styled.BreadBoxContainer
                        isVisible={openHoverCard}
                        style={{ minWidth: "220px", right: "0" }}
                      >
                        <div className="actionText" onClick={onFilter}>
                          <div className="actionIcon left">
                            <IconSvgBreadCrumb
                              width="25"
                              height="25"
                              filtre={true}
                              color="rgb(0, 122, 223)"
                            />
                          </div>
                          <p className="actionTitle left">
                            {i18next.t("filtres")}
                          </p>
                        </div>
                        <div className="actionText" onClick={onFilterReset}>
                          <div className="actionIcon left">
                            <IconSvgBreadCrumb
                              width="25"
                              height="25"
                              filtre={true}
                              color="#9a9696"
                            />
                          </div>
                          <p className="actionTitle left">
                            {i18next.t("reinitialiser les filtres")}
                          </p>
                        </div>
                        <div className="actionText">
                          <div className="actionIcon left">
                            <IconSvgBreadCrumb
                              width="25"
                              height="25"
                              upload={true}
                            />
                          </div>
                          <p className="actionTitle left">
                            <CSVLink
                              target="_blank"
                              filename="export-lapi-incident.csv"
                              data={csvData}
                            >
                              {i18next.t("exporter en csv")}
                            </CSVLink>
                          </p>
                        </div>
                        <div className="actionText" onClick={onExtractPdf}>
                          <div className="actionIcon left">
                            <IconSvgBreadCrumb
                              width="25"
                              height="25"
                              exportFilePDF={true}
                            />
                          </div>
                          <p className="actionTitle left">
                            {" "}
                            {i18next.t("extraire le pdf")}
                          </p>
                        </div>
                      </Styled.BreadBoxContainer>
                    </Styled.Container>
                  </span>
                </div>
              </div>
            )}

          {addIhnibition &&
            Utils.simpleAuthorizationIsAllowed(User, [
              Enums.AuthorizationRightsEnums.INHIBITIONCREATED,
            ]) && (
              <div className="breadCrumbLeft left ">
                <div className="breadCrumbContainer">
                  <span className="breadCrumbText">
                    <Styled.Container onClick={onOpenInhibitionModal}>
                      <Styled.BreadContainerBalise
                        style={{
                          background: "#007ADF",
                          border: "none",
                          width: "auto",
                          cursor: "pointer",
                        }}
                      >
                        <p
                          style={{
                            marginRight: "35px",
                            padding: "0 5px 0 10px",
                            color: "white",
                          }}
                        >
                          {" "}
                          {i18next.t("ajouter une inhibition")}
                        </p>
                        <Styled.Icon style={{ width: "10px", right: "10px" }}>
                          <StyledIcon supervision={true} color="white" />
                        </Styled.Icon>
                      </Styled.BreadContainerBalise>
                    </Styled.Container>
                  </span>
                </div>
              </div>
            )}
          {ficheIncident &&
            actionFinished &&
            (Utils.simpleAuthorizationIsAllowed(User, [
              Enums.AuthorizationRightsEnums.INCIDENTFILEEXPORTERPDF,
            ]) ||
              Utils.simpleAuthorizationIsAllowed(User, [
                Enums.AuthorizationRightsEnums.INCIDENTFILEEXPORTERVIDEO,
              ])) && (
              <div className="breadCrumbLeft left ">
                <div className="breadCrumbContainer">
                  <span className="breadCrumbText">
                    <Styled.Container onMouseLeave={onClosehoverCard}>
                      <Styled.BreadContainerBalise
                        onClick={onOpenhoverCard}
                        style={{
                          background: "#007ADF",
                          border: "none",
                          width: "auto",
                          cursor: "pointer",
                        }}
                      >
                        <p
                          style={{
                            marginRight: "35px",
                            padding: "0 5px 0 10px",
                            color: "white",
                          }}
                        >
                          {i18next.t("actions")}
                        </p>
                        <Styled.IconRotate
                          rotates={!openHoverCard}
                          style={{ width: "10px", right: "10px" }}
                        >
                          <StyledIcon arrowWite={true} />
                        </Styled.IconRotate>
                      </Styled.BreadContainerBalise>
                      <Styled.BreadBoxContainer
                        isVisible={openHoverCard}
                        style={{ minWidth: "180px", right: "0" }}
                      >
                        {Utils.simpleAuthorizationIsAllowed(User, [
                          Enums.AuthorizationRightsEnums
                            .INCIDENTFILEEXPORTERPDF,
                        ]) && (
                          <div className="actionText" onClick={onExtractPdf}>
                            <div className="actionIcon left">
                              <IconSvgBreadCrumb
                                width="25"
                                height="25"
                                exportFilePDF={true}
                              />
                            </div>
                            <p className="actionTitle left">
                              {" "}
                              {i18next.t("extraire le pdf")}
                            </p>
                          </div>
                        )}

                        {Utils.simpleAuthorizationIsAllowed(User, [
                          Enums.AuthorizationRightsEnums
                            .INCIDENTFILEEXPORTERVIDEO,
                        ]) && (
                          <div className="actionText" onClick={onExtractVideo}>
                            <div className="actionIcon left">
                              <IconSvgBreadCrumb
                                width="25"
                                height="25"
                                exportCamera={true}
                              />
                            </div>
                            <p className="actionTitle left">
                              {" "}
                              {i18next.t("extraire la video")}
                            </p>
                          </div>
                        )}
                      </Styled.BreadBoxContainer>
                    </Styled.Container>
                  </span>
                </div>
              </div>
            )}

          {cameraIsExist &&
            (Utils.simpleAuthorizationIsAllowed(User, [
              Enums.AuthorizationRightsEnums.CAMERASEGMENTATION,
            ]) ||
              Utils.simpleAuthorizationIsAllowed(User, [
                Enums.AuthorizationRightsEnums.CAMERAADDED,
              ]) ||
              Utils.simpleAuthorizationIsAllowed(User, [
                Enums.AuthorizationRightsEnums.CAMERAEXPORTERCSV,
              ])) && (
              <div className="breadCrumbLeft left ">
                <div className="breadCrumbContainer">
                  <span className="breadCrumbText">
                    <Styled.Container onMouseLeave={onClosehoverCard}>
                      <Styled.BreadContainerBalise
                        onClick={onOpenhoverCard}
                        style={{
                          background: "#007ADF",
                          border: "none",
                          width: "auto",
                          cursor: "pointer",
                        }}
                      >
                        <p
                          style={{
                            marginRight: "35px",
                            padding: "0 5px 0 10px",
                            color: "white",
                          }}
                        >
                          {i18next.t("actions")}
                        </p>
                        <Styled.IconRotate
                          rotates={!openHoverCard}
                          style={{ width: "10px", right: "10px" }}
                        >
                          <StyledIcon arrowWite={true} />
                        </Styled.IconRotate>
                      </Styled.BreadContainerBalise>
                      <Styled.BreadBoxContainer
                        isVisible={openHoverCard}
                        style={{ minWidth: "220px", right: "0" }}
                      >
                        {Utils.simpleAuthorizationIsAllowed(User, [
                          Enums.AuthorizationRightsEnums.CAMERASEGMENTATION,
                        ]) && (
                          <div className="actionText" onClick={onSegmented}>
                            <div className="actionIcon left">
                              <IconSvgBreadCrumb
                                width="25"
                                height="25"
                                supervision={true}
                              />
                            </div>
                            <p className="actionTitle left">
                              {" "}
                              {i18next.t("assistant segmentation")}
                            </p>
                          </div>
                        )}

                        {Utils.simpleAuthorizationIsAllowed(User, [
                          Enums.AuthorizationRightsEnums.CAMERAADDED,
                        ]) && (
                          <div className="actionText">
                            <div className="actionIcon left">
                              <IconSvgBreadCrumb
                                width="25"
                                height="25"
                                exportCamera={true}
                              />
                            </div>
                            <p className="actionTitle left">
                              <Link
                                to={{
                                  pathname: Paths.PathsNamesEnums.CAMERACREATED,
                                }}
                              >
                                {" "}
                                {i18next.t("creation d-une camera")}
                              </Link>
                            </p>
                          </div>
                        )}

                        {Utils.simpleAuthorizationIsAllowed(User, [
                          Enums.AuthorizationRightsEnums.CAMERAEXPORTERCSV,
                        ]) && (
                          <div
                            className="actionText"
                            onClick={onExportCSVCamera}
                          >
                            <div className="actionIcon left">
                              <IconSvgBreadCrumb
                                width="25"
                                height="25"
                                exportFilePDF={true}
                              />
                            </div>
                            <p className="actionTitle left">
                              {" "}
                              {i18next.t("exporter les cameras")}
                            </p>
                          </div>
                        )}
                      </Styled.BreadBoxContainer>
                    </Styled.Container>
                  </span>
                </div>
              </div>
            )}
          {UsersAdd &&
            Utils.simpleAuthorizationIsAllowed(User, [
              Enums.AuthorizationRightsEnums.ADMINISTRATIONUSERSADDED,
            ]) && (
              <div className="breadCrumbLeft left ">
                <div className="breadCrumbContainer">
                  <span className="breadCrumbText">
                    <Styled.Container onClick={onOpenAddUser}>
                      <Styled.BreadContainerBalise
                        style={{
                          background: "#007ADF",
                          border: "none",
                          width: "auto",
                          cursor: "pointer",
                        }}
                      >
                        <p
                          style={{
                            marginRight: "35px",
                            padding: "0 5px 0 10px",
                            color: "white",
                          }}
                        >
                          {i18next.t("ajouter un utilisateur")}
                        </p>
                        <Styled.Icon style={{ width: "10px", right: "10px" }}>
                          <StyledIcon userAdd={true} color="white" />
                        </Styled.Icon>
                      </Styled.BreadContainerBalise>
                    </Styled.Container>
                  </span>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onOpenAddUser?: any;
  title?: string;
  links: string;
  links1: string;
  UsersAdd?: boolean;
  breadText1?: string;
  breadText2?: string;
  actionFinished?: boolean;
  addIhnibition?: boolean;
  filtreHistory?: boolean;
  cameraIsExist?: boolean;
  cameraIsSegmentation?: boolean;
  actionInProgress?: boolean;
  paramLinks?: any;
  openHoverCard?: boolean;
  ficheIncident?: boolean;
  csvData?: any;
  onFilter?: React.EventHandler<React.MouseEvent<HTMLElement>>;
  onOpenhoverCard: any;
  onExtractPdf: React.EventHandler<React.MouseEvent<HTMLElement>>;
  onExtractVideo: React.EventHandler<React.MouseEvent<HTMLElement>>;
  onFilterReset?: React.EventHandler<React.MouseEvent<HTMLElement>>;
  onOpenInhibitionModal?: React.EventHandler<React.MouseEvent<HTMLElement>>;
  onSegmented?: React.EventHandler<React.MouseEvent<HTMLElement>>;
  iconIncident?: boolean;
  iconExplorer?: boolean;
  iconAdministration?: boolean;
  iconSupervision?: boolean;
  onExportCSVCamera?: any;
  filtreHistoryCitilog?: boolean;
  onClosehoverCard?: any;
  explorersearch?: any;
  onExplorerSearch?: any;
  onExplorerSearchChange?: any;
  onPenSearchIncidents?: any;
  bulles?: any;
  onClearIncidentSearch?: any;
  filtreLapi?: any;
  lapiincons?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/breadcrumb/component.tsx